const capitalizeWords = (str) => {
  if (str) {
    if (str === "styleaccent") {
      return "Style & Accent";
    }
    // return str.split(' ').map(word =>
    //     word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    // ).join(' ');
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }
  return str;
};

export default capitalizeWords;
